import React, { useState } from "react";
import CommentIcon from "@mui/icons-material/Comment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import moment from "jalali-moment";

// import JS files

// import others files
import { useNavigate } from "react-router-dom";

const PersonsCard = (props) => {
    const navigate = useNavigate();

  return (
    <>
      <div
        className=" bg-mygrays-100 p-4 rounded-lg flex flex-col items-center cursor-pointer text-hover-container"
        onClick={() => navigate(`/news-content/${props.data.id}`)}
      >
        <img
          src={props.data.news_detail[0].cover}
          className="w-full h-48 rounded-lg pc-img"
        />
        <div className="bg-white rounded-lg p-4 flex flex-col w-full my-2 ">
          <span className="text-myblacks-400 font-bold text-sm md:text-base">
            {props.data.news_detail[0].person_name}
          </span>
          <span className="text-myblacks-300 text-xs md:text-sm mt-1 opacity-75">
            {props.data.news_detail[0].person_position}
          </span>
        </div>
        <div className="self-start">
          <span className="text-xs md:text-sm leading-6 text-hover">
            {props.data.news_detail[0].header}{" "}
          </span>
        </div>
        {props.showDate ? <div className="self-end flex justify-end text-xs text-myblacks-100 mt-4 md:mt-8">
          <div className="flex items-center">
            <CommentIcon sx={{ fontSize: "1rem" }} />
            <span className="mr-1">{props.data.ticket_num} نظر</span>
          </div>
          <div className="flex items-center mr-8">
            <CalendarMonthIcon sx={{ fontSize: "1rem" }} />
            <span className="mr-1" style={{ fontFamily: "yekan" }}>
              {" "}
              {moment(props.data.news_detail[0].publish_at, "YYYY/MM/DD")
                .locale("fa")
                .format("YYYY/MM/DD")}
            </span>
          </div>
        </div> : ""}
      </div>
    </>
  );
};

export default PersonsCard;
